import { render } from "./CeremonyCardTopRow.vue?vue&type=template&id=a2047630&scoped=true"
import script from "./CeremonyCardTopRow.vue?vue&type=script&lang=js"
export * from "./CeremonyCardTopRow.vue?vue&type=script&lang=js"

import "./CeremonyCardTopRow.vue?vue&type=style&index=0&id=a2047630&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2047630"]])

export default __exports__